import { AiFillCar } from "react-icons/ai";

const CarIcon = (props) => {
  return <AiFillCar className={props.className} />;
};

export default CarIcon;